import React, { useEffect } from 'react';

import ApexCharts from 'apexcharts';
import Chart from 'react-apexcharts';

import { decimalUpTo } from 'Helpers/currencyFormat';

let colorPalette = ['#B5B2AC', '#000061', '#ffd145'];

const VenuesChart = ({ data, urlProfitAndLoss }) => {
    const slugs = data.filter((e) => e.revenues > 0 || e.expenses > 0).map((e) => e.slug);

    useEffect(() => {
        const labels = [];
        const series = [
            {
                name: 'Revenues',
                data: [],
                type: 'column',
            },
            {
                name: 'Expenditures',
                data: [],
                type: 'column',
            },
        ];
        data.forEach((e) => {
            if (e.revenues > 0 || e.expenses > 0) {
                labels.push(e.name);
                series[0].data.push(e.revenues);
                series[1].data.push(e.expenses);
                // series[2].data.push(e.revenues - e.expenses)
            }
        });
        ApexCharts.exec('total-venues', 'updateOptions', {
            labels: labels,
        });
        ApexCharts.exec('total-venues', 'updateSeries', series);
    }, []);

    const barOption = {
        chart: {
            fontFamily: 'var(--font-sans)',
            id: 'total-venues',
            type: 'bar',
            height: 380,
            width: '100%',
            stacked: false,
            toolbar: {
                tools: {
                    download: false,
                    pan: false,
                    reset: false,
                    selection: false,
                    zoom: false,
                },
            },
            events: {
                dataPointSelection: (event, chartContext, config) => {
                    window.location.href = urlProfitAndLoss.replace('VENUE_SLUG', slugs[config.dataPointIndex]);
                },
            },
        },
        tooltip: {
            y: {
                formatter: function (val) {
                    // if(val < 0) {
                    //     val = Math.abs(val)
                    // }
                    return decimalUpTo(val.toFixed(0));
                },
            },
        },

        colors: colorPalette,
        series: [
            {
                name: 'Revenues',
                data: [],
                type: 'column',
            },
            {
                name: 'Expenditures',
                data: [],
                type: 'column',
            },
        ],
        labels: [],
        xaxis: {
            type: 'category',
            labels: {
                show: false,
                rotate: 0,
            },
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            },
        },
        yaxis: {
            opposite: true,
            axisBorder: {
                show: false,
            },
            axisTicks: {
                show: false,
            },
            labels: {
                style: {
                    colors: '#78909c',
                },
                formatter: function (val) {
                    return decimalUpTo(val.toFixed(0));
                },
            },
        },
        legend: {
            show: true,
        },
        title: {
            text: 'Venues',
            align: 'left',
            style: {
                fontSize: '18px',
                color: '#000061',
            },
        },
    };

    return <Chart options={barOption} series={barOption.series} type="line" height={200} />;
};

export default React.memo(VenuesChart);
